import { render, staticRenderFns } from "./MobileMaterialSetter.vue?vue&type=template&id=c2e37060&"
import script from "./MobileMaterialSetter.vue?vue&type=script&lang=js&"
export * from "./MobileMaterialSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports